import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Client } from '../types/Client';
import { objectToQueryParams } from '../../utils/query.functions';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  prefix = `${environment.serverUrl}/clients`;

  constructor(private http: HttpClient) {}

  async getClients(params?: {
    name?: string;
    withAtLeastOneContract?: boolean;
    salesGroupId?: string;
    locations?: 'only-with' | 'only-without';
  }): Promise<Client[]> {
    return await this.http.get<Client[]>(`${this.prefix}?${objectToQueryParams(params)}`).toPromise();
  }

  async getClientById(id: string): Promise<Client> {
    return this.http.get<Client>(`${this.prefix}/${id}`).toPromise();
  }

  async addClient(client: Client): Promise<Client> {
    return await this.http.post<Client>(`${this.prefix}`, client).toPromise();
  }

  editClient(client: Client) {
    return this.http.put(`${this.prefix}/${client.id}`, client).toPromise();
  }

  async deleteClient(clientId: string): Promise<any> {
    return await this.http.delete(`${this.prefix}/${clientId}`).toPromise();
  }
}
